import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import SeoHelmet from '../components/SeoHelmet'
import { seo } from '../config/seo'
import '../styles/home.css'
import video from '../static/videos/skiland.mp4'
import next from '../static/pictures/next.png'
import warning from '../static/pictures/warning.png'
import 'animate.css'
import Information from '../components/Information'

import eltime from '../static/pictures/partneri/eltime.png'
import euro from '../static/pictures/partneri/euro.png'
import phone from '../static/pictures/phone-call.png'
import email from '../static/pictures/email.png'
import gps from '../static/pictures/gps.png'
import cloud from '../static/pictures/cloudy.png'
import wind from '../static/pictures/wind.png'
import temp from '../static/pictures/temperature.png'
import humi from '../static/pictures/humidity.png'

import { getEvents } from '../functions/getEvents'
import { filterEvents } from '../functions/filterEvents'
import { trimText } from '../functions/trimText'
import { fixedDate } from '../functions/dates'
import { getImportant } from '../functions/getImportant'
import { getWeatherData } from '../functions/getWeatherData'
import { getAllInstructors } from '../functions/getAllInstructors'
import { filterInstructors } from '../functions/filterInstructors'
import { seasonChecking } from '../functions/seasonChecking'
import { getWarnings } from '../functions/getWarnings'
import { getPricelist } from '../functions/getPricelist'

const Home = ({ kontaktRef, cennikRef, instruktoriRef, uvodRef }) => {

  const isSummer = seasonChecking();

  const vidRef = useRef();
  const letoLandscapeRef = useRef();
  const letoPortraitRef = useRef();

  useEffect(() => {
    if (!isSummer) {
      vidRef.current?.play();
    } else {
      letoLandscapeRef.current?.play();
      letoPortraitRef.current?.play();
    }
  }, [isSummer]);


  //Get all necessary things..

  //Order of tickets or skiing
  const [selling, setSelling] = useState(0);
  const [sellingText, setSellingText] = useState("Lístky");

  //Backend content variables
  const [information, setInformation] = useState([]);
  const [infoPage, setInfoPage] = useState(1);
  const [sortedInfo, setSortedInfo] = useState([]);
  const [warnings, setWarnings] = useState([]);

  //Events filtered (old and new)
  const [eventsNew, setEventsNew] = useState([]);
  const [eventsOld, setEventsOld] = useState([]);

  const [isMobile, setIsMobile] = useState(false);
  const [important, setImportant] = useState(null);

  const [weather, setWeather] = useState({});
  const [loaded, setLoaded] = useState(false);

  const [pricelist, setPricelist] = useState({ tickets: [], ticketInfo: [], ticketWarning: '', rental: [], rentalWarning: '' });
  const [instructorsLyzovanie, setInstructorsLyzovanie] = useState([]);
  const [instructorsSnowboard, setInstructorsSnowboard] = useState([]);

  const navigate = useNavigate();

  const sellingChoice = () => {
    if (!selling) {
      setSelling(1);
      setSellingText("Požičovňa")
    } else {
      setSelling(0);
      setSellingText("Lístky");
    }
  }

  const handleResize = () => {
    if (window.innerWidth < 600) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }


  useEffect(() => {
    async function OnStart() {
      const weatherData = await getWeatherData();
      setWeather(weatherData.data);
      const eventData = await getEvents();
      const filteredNew = filterEvents(eventData.data, 0, 2);
      const filteredOld = filterEvents(eventData.data, 1, eventData.data.length);
      const threeMonthsAgo = new Date();
      threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
      const recentOldEvents = filteredOld
        .filter((event) => new Date(event.startDate).getTime() >= threeMonthsAgo.getTime())
        .slice(0, 2);
      const importantResponse = await getImportant();

      const instructorsData = await getAllInstructors();
      const filterInstructorsLyzovanie = filterInstructors(instructorsData.instructors, 0);
      const filterInstructorsSnowboard = filterInstructors(instructorsData.instructors, 1);
      const pricelistResponse = await getPricelist();
      if (pricelistResponse.ok) setPricelist(pricelistResponse.data);
      setInstructorsLyzovanie(filterInstructorsLyzovanie);
      setInstructorsSnowboard(filterInstructorsSnowboard);

      setImportant(importantResponse?.data || null);
      setEventsNew(filteredNew);
      setEventsOld(recentOldEvents);
      setLoaded(true);
    }
    handleResize();
    window.addEventListener("resize", handleResize);
    OnStart();
    axios.get(`${process.env.REACT_APP_API_HOST}/information/all`).then((resp) => {
      const items = (resp.data || []).filter(Boolean);
      setInformation(items);
      setSortedInfo(items.slice(0, 2));
    });
    getWarnings().then((data) => setWarnings(data));
    //axios.get(`${process.env.REACT_APP_API_HOST}/events`).then(resp => {setEventInfo(resp.data.data)});
  }, []);

  return (
    <div className="home-page">
      <SeoHelmet title={seo.pages.home.title} description={seo.pages.home.description} path="/" />
      <div className='video-show' ref={uvodRef}>
        {console.log(isSummer)}

        {!isSummer ?
          <video
            id="myVideo"
            src={"https://skiland.sk/static/skiland.webm"}
            ref={vidRef}
            muted
            autoPlay
            loop
            playsInline
          /> :
          <>
            <video
              className="leto-video leto-video-landscape"
              src="/skiland_leto_landscape.mp4"
              ref={letoLandscapeRef}
              muted
              autoPlay
              loop
              playsInline
            />
            <video
              className="leto-video leto-video-portrait"
              src="/skiland_leto_portrait.mp4"
              ref={letoPortraitRef}
              muted
              autoPlay
              loop
              playsInline
            />
          </>}

        <div className='cover-video'>
          <div className="content-box">
            <h1 className="animate__animated animate__slideInDown">Víta Vás Skiland</h1>
            <p className="animate__animated animate__slideInDown">Lyžiarske stredisko Skiland Stará Myjava</p>
          </div>
        </div>
        {console.log(important)}

        {important && (important.header || important.content) ? <div className="dolezite">
          {important.header ? <h2 style={isSummer ? { color: '#84d9ad' } : { color: '#25aae1' }}>{important.header}</h2> : ""}
          {important.content ? <p>{important.content}</p> : ""}
        </div> : ""}

        {loaded ? <div className="weather">
          <h2 style={isSummer ? { color: '#84d9ad' } : { color: '#25aae1' }}>Počasie</h2>
          <div className="weather-item">
            <img src={temp} alt="" />
            <p>{weather.main.temp} °C</p>
          </div>
          <div className="weather-item">
            <img src={wind} alt="" />
            <p>{weather.wind.speed} m/s</p>
          </div>
          <div className="weather-item">
            <img src={humi} alt="" />
            <p>{weather.main.humidity} %</p>
          </div>
        </div> : ""}
      </div>

      <div className='information-tab'>

        <div className="info" style={{ flexBasis: '50%', padding: '30px' }}>
          <div className="information-header" style={isSummer ? { background: '#84d9ad' } : { background: '#25aae1' }}>
            <div className="information-text">Informácie</div>
          </div>

          <div className="information-content">
            {sortedInfo.filter(Boolean).map((info, index) => (
              <Information color={1} key={info.id || index} header={info.header} text={info.text} date={info.createdAt} />
            ))}
          </div>
        </div>

        <div className="upozornenia" style={{ flexBasis: '50%', padding: '30px' }}>
          <div className="information-header" style={{ width: '180px', background: '#ff6174' }}>
            <div className="information-text" style={{ color: 'black' }}>Upozornenia</div>
          </div>

          <div className="information-content">
            {warnings.map((warning, index) => (
              <Information color={2} key={warning.id || index} header={warning.header} text={warning.text} date={warning.createdAt} />
            ))}
          </div>
        </div>
      </div>

      <div className="support-tab">
        <div className="support-header" style={isSummer ? { background: '#84d9ad' } : { background: '#25aae1' }}>
          <div className="support-text">Podpora</div>
        </div>
        <div className="support-content">
          <div className="support-message">
            <h2>Keď nejazdíš vlekom, podpor dobrovoľným príspevkom na údržbu trailov</h2>
            <p>Stačí naskenovať QR kód a pomôcť nám držať traily v top stave.</p>
          </div>
          <div className="support-qr-wrapper">
            <img src="/skiland_podpora.png" alt="QR kód na podporu údržby trailov" />
          </div>
        </div>
      </div>

      {!isSummer ? <div className="cennik-tab" ref={cennikRef}>
        <div className="cennik-header" id="cennik-id" style={isSummer ? { background: '#84d9ad' } : { background: '#25aae1' }}>
          <div className="cennik-text">Cenník</div>
        </div>
        <div className="cennik-table">
          <table>
            <tr>
              <th style={isSummer ? { color: '#84d9ad' } : { color: '#25aae1' }}>Lístok</th>
              <th style={isSummer ? { color: '#84d9ad' } : { color: '#25aae1' }}>Dospelý</th>
              <th style={isSummer ? { color: '#84d9ad' } : { color: '#25aae1' }}>Dieťa</th>
            </tr>
            {pricelist.tickets.map((ticket, index) => <tr key={index}>
              <td>{ticket.name}</td>
              <td>{ticket.adult}</td>
              <td>{ticket.child}</td>
            </tr>)}
          </table>
        </div>

        <div className="cennik-informacie">
          <p id="info">
            {pricelist.ticketInfo.map((line, index) => <React.Fragment key={index}>{line}<br /></React.Fragment>)}
            {pricelist.ticketWarning ? <div id="important"><img src={warning} /><span>{pricelist.ticketWarning}</span></div> : ''}
          </p>
        </div>

        {isSummer === false ? <div className="cennik-table">
          {isMobile ? <p style={{ color: 'white', textAlign: 'left' }}>{pricelist.rental.map((item, index) => <React.Fragment key={index}>{index + 1}. {item.name}<br /></React.Fragment>)}</p> : ""}
          <table style={{ width: '90%' }}>
            <tr>
              <th colspan="6" >Požičovňa</th>
            </tr>
            <tr>
              <th></th>
              <th>1 hod.</th>
              <th>2 hod.</th>
              <th>3 hod.</th>
              <th>4 hod.</th>
              <th id="breakWord">Deň</th>
            </tr>
            {pricelist.rental.map((item, index) => <tr key={index}>
              <td>{isMobile ? `${index + 1}.` : item.name}</td>
              <td>{item.h1}</td>
              <td>{item.h2}</td>
              <td>{item.h3}</td>
              <td>{item.h4}</td>
              <td>{item.day}</td>
            </tr>)}
          </table>
        </div> : ''}

        {isSummer === false && pricelist.rentalWarning ? <div className="cennik-informacie">
          <p id="info">
            <div id="important"><img src={warning} />{pricelist.rentalWarning}</div>
          </p>
        </div> : ''}

      </div> : ""}

      {eventsNew.length > 0 || eventsOld.length > 0 ? <div className="podujatia">
        <div className="podujatia-header" style={isSummer ? { background: '#84d9ad' } : { background: '#25aae1' }}>
          <div className="podujatia-text">Podujatia</div>
        </div>
        <div className="podujatia-mainflex">
          {eventsNew.length > 0 ? <div className="podujatia-mainflex-new">
            <h2 style={isSummer ? { color: '#84d9ad' } : { color: '#25aae1' }}>Najbližšie podujatia</h2>

            {eventsNew.map((event, index) =>
              <div key={index} onClick={() => navigate(`event-item/${event.id}`)} className="podujatie-item">
                <img src={process.env.REACT_APP_API_HOST + "/static/" + event.photos[0]} alt="test" />
                <div className="podujatieItem-info">
                  <h2>{event.header}</h2>
                  <small style={{ color: 'gray' }}>Dátum začiatku: {fixedDate(event.startDate)}</small>
                  <p>{trimText(event.text, 150)}</p>
                </div>
              </div>)}
            <div className="more" style={{ textAlign: 'center' }}>
              <Link to="events" style={{ color: 'white', margin: '0 auto' }}>Zobraziť podujatia</Link>
            </div>
          </div> : ""}
          {eventsOld.length > 0 ? <div className="podujatia-mainflex-old">
            <h2 style={isSummer ? { color: '#84d9ad' } : { color: '#25aae1' }}>Nedávne podujatia</h2>
            {eventsOld.map((event, index) =>
              <div key={index} onClick={() => navigate(`archive-item/${event.id}`)} className="podujatie-item">
                <img src={process.env.REACT_APP_API_HOST + "/static/" + event.photos[0]} alt="test" />
                <div className="podujatieItem-info">
                  <h2>{event.header}</h2>
                  <small style={{ color: 'gray' }}>Konané dňa: {fixedDate(event.startDate)}</small>
                  <p>{trimText(event.text, 150)}</p>
                </div>
              </div>)}
            <div className="more" style={{ textAlign: 'center' }}>
              <Link to="archive" style={{ color: 'white', margin: '0 auto' }}>Zobraziť archív</Link>
            </div>
          </div> : ""}
        </div>
      </div> : ""}

      {isSummer === false ? <div className="instruktor-tab" ref={instruktoriRef}>
        <div className="instruktor-header">
          <div className="instruktor-text">Inštruktori</div>
        </div>
        <div className="instruktor-table">
          <table>
            <tr>
              <th colspan="2">Lyžovanie</th>
            </tr>
            <tr>
              <th>Meno</th>
              <th>Telefón</th>
            </tr>
            {instructorsLyzovanie.map((instruktor, index) => <tr tabIndex={index}>
              <td>{instruktor.meno}</td>
              <td>{instruktor.telefon}</td>
            </tr>)}
          </table>
          <table>
            <tr>
              <th colspan="2">Snowboarding</th>
            </tr>
            <tr>
              <th>Meno</th>
              <th>Telefón</th>
            </tr>
            {instructorsSnowboard.map((instruktor, index) => <tr tabIndex={index}>
              <td>{instruktor.meno}</td>
              <td>{instruktor.telefon}</td>
            </tr>)}
          </table>
        </div>
      </div> : ''}

      <div className="partneri">
        <div className="partneri-header" style={isSummer ? { background: '#84d9ad' } : { background: '#25aae1' }}>
          <div className="partneri-text">Partneri</div>
        </div>
        <h2 style={{ color: 'white', textAlign: 'center' }}>Tieto firmy o nás hovoria</h2>
        <div className="partners-logos">
          <img style={{ borderRadius: '0px' }} src={eltime} />
          <img style={{ borderRadius: '0px', height: '50px' }} src={euro} />
        </div>
      </div>
      <div className="lokacia">
        <div className="lokacia-header" style={isSummer ? { background: '#84d9ad' } : { background: '#25aae1' }}>
          <div className="lokacia-text">Poloha</div>
        </div>
        <h2 id="header">Chcete vedieť, kde sa nachádzame? Pozrite sa tu</h2>
        <div className="google-maps">
          <iframe src="https://maps.google.com/maps?width=100%25&amp;hl=en&amp;q=skiland%20star%C3%A1%20myjava+&amp;t=&amp;z=10&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" width="100%" height="600" style={{ border: '0px', margin: '0 auto', borderRadius: '20px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      <div className="kontakt" ref={kontaktRef}>
        <div className="kontakt-header" style={isSummer ? { background: '#84d9ad' } : { background: '#25aae1' }}>
          <div className="kontakt-text">Kontakt</div>
        </div>
        <div className="contant-content">
          <h3>Telefónne číslo</h3>
          <div className='contact-telephone'>
            <img src={phone} alt="phone" />
            <a href="tel:+420731030399">+420 731 030 399</a>
          </div>
          <h3>Emailová adresa</h3>
          <div className='contact-telephone'>
            <img src={email} alt="phone" />
            <p>skiland.staramyjava@seznam.cz</p>
          </div>
          <h3>Adresa miesta</h3>
          <div className='contact-telephone'>
            <img src={gps} alt="phone" />
            <p>Stará Myjava 411, Slovensko</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home